<template>
    <BlockWrapper
        v-for="block in pageBlocks"
        :key="block.canonicalUid"
        :block="block"
    />
</template>

<script setup>
    import BlockWrapper from '~/components/blocks/BlockWrapper.vue'

    const { entry } = storeToRefs(useEntryStore())

    const pageBlocks = computed(() => {
        return get(entry.value, 'contentBuilder', [])
    })

</script>
